import React from 'react';
import styles from './styles.module.scss';
import colorAlpha from 'color-alpha';
import Chip, { ChipProps } from '../Chip';

import colorVariables from '@densityco/ui/variables/colors.json';

const StatusTag: React.FunctionComponent<{
  status: string;
  size?: ChipProps['size'];
}> = ({ size, status }) => {
  let color = colorVariables.gray700;
  if (status === 'online') {
    color = colorVariables.green;
  } else if (status === 'error') {
    color = colorVariables.red;
  } else if (status === 'low_power') {
    color = colorVariables.yellow;
  }

  return <Chip
    backgroundColor={colorAlpha(color, 0.2)}
    color={color}
    size={size}
  >
    {status.toUpperCase()}
  </Chip>
};

export default StatusTag;
